@if (route()) {
  <a
    class="cell"
    [routerLink]="route()"
    [style.--progress-label-width]="
      this.progressBarTextMaxLength() && this.progressBarTextMaxLength()
    "
  >
    <ng-container
      *ngTemplateOutlet="
        cellTemplate();
        context: { cell: cell(), row: row(), rowId: rowId() }
      "
    ></ng-container>
  </a>
} @else {
  <div
    class="cell"
    [style.--progress-label-width]="
      this.progressBarTextMaxLength() && this.progressBarTextMaxLength()
    "
  >
    <ng-container
      *ngTemplateOutlet="
        cellTemplate();
        context: { cell: cell(), row: row(), rowId: rowId() }
      "
    ></ng-container>
  </div>
}
<ng-template #defaultCellTemplate let-cell="cell">
  @for (value of cell.values; track $index) {
    <pozi-cell-value [cellValue]="value"></pozi-cell-value>
    @if (value.hasOwnProperty('text') && cell.metadata?.splitBy && !$last) {
      <span class="split-by" [style.color]="cell.metadata?.splitByColor ?? ''">
        {{ cell.metadata?.splitBy }}
      </span>
    }
  }
  @if (!cell.values || !cell.values.length) {
    <span class="empty"></span>
  }
</ng-template>
